import { Stack, useTheme } from '@mui/material'
import { Typography } from 'ComponentLibrary'
import React from 'react'

export function ValueLabel({ label, value }: { label: string; value: string }) {
    const theme = useTheme()

    return (
        <Stack direction="row" justifyContent="space-between">
            <Typography variant="bodyTextSmall" color={theme.palette.customtext.black54} style={{ whiteSpace: 'nowrap' }}>
                {label}
            </Typography>
            <Typography variant="bodyTextSmall" color={theme.palette.customtext.black100} style={{ textAlign: 'end' }}>
                {value}
            </Typography>
        </Stack>
    )
}
